import { yuanDigit } from '@/utils/string';

export function yuan(value: number) {
  return `¥${yuanDigit(value)}`;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/filters/yuan.ts